<template>
  <div class="flex gap-2">
    <text-input
      v-model="clipboardText"
      :readonly="true"
      value="clipboardText"
      :select-all="true"
    />
    <gd-button
      v-clipboard:copy="value"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
      size="icon"
      variant="primary"
    >
      <copy-icon class="fill-current w-4 h-4"/>
    </gd-button>
  </div>
</template>


<script>
import Notify from '../notify';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import CopyIcon from '../assets/icons/copy.svg';
import GdButton from './Button';
import TextInput from './TextInput';

Vue.use(VueClipboard);

export default {
  name: 'InputWithClipboard',
  inheritAttrs: false,
  props: ['value'],
  components: {
    GdButton,
    TextInput,
    CopyIcon
  },
  data() {
    return {
      clipboardText: this.value,
    };
  },
  methods: {
    onCopy() {
      Notify.success(this.$t('frontend_copied_to_clipboard'));
    },
    onError() {
      Notify.fail(this.$t('frontend_copied_failed_clipboard'));
    },
  },
};
</script>
